import { z } from "zod";

import http from "@/services/http";

const enrollgenAIParams = z.object({
  genai_opt_in: z.boolean().nullish(),
  genai_opt_out: z.boolean().nullish(),
  dnm_opt_out: z.boolean().nullish(),
  dnm_opt_in: z.boolean().nullish(),
  genai_survey: z.boolean().nullish(),
  genai_interview: z.boolean().nullish(),
  genai_agreement: z.boolean().nullish(),
  ciscou_agreement: z.boolean().nullish(),
  ai_opt_in: z.boolean().nullish(),
  ai_opt_out: z.boolean().nullish(),
});

export type ContentParams = z.infer<typeof enrollgenAIParams>;

export async function enrollGenAIUser(content: ContentParams) {
  if (!window.env.API_PROFILE) {
    return;
  }
  return await http().post(`${window.env.API_PROFILE}/enrollGenAI`, content);
}
